import CloseIconImage from "../../images/components/alert/close-icon.svg";

function SignAlert({data, setAlert}) {
    return (
        <div className="SignAlert">
            <button
                className="CloseButton"
                type="button"
                onClick={()=>setAlert(false)}
            >
                <img src={CloseIconImage} alt="close button" />
            </button>
            <div className="AlertContent">
                {data.title.length > 0 &&
                    <div className="Title">
                        {data.title.map((e, idx)=>
                            <div key={idx}>{e}</div>
                        )}
                    </div>
                }
                {data.description.length>0 &&
                    <div className="Description">
                        {data.description.map((e, idx)=>
                            <div key={idx}>{e}</div>
                        )}
                    </div>
                }
            </div>            
            {data.button &&
                <button
                    className="SubmitButton"
                    type="button"
                    onClick={()=>setAlert(false)}
                >
                    {data.button}
                </button>
            }            
        </div>
    );
}

export default SignAlert;